import { Typography, IconButton, makeStyles, Avatar, Button } from '@material-ui/core';
import React from 'react';
import ApprovalViewer from './ApprovalViewer';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import SourceViewerDialogFields from '../../ManageAsset/Sources/SourceViewerDialogFields';

const useStyles = makeStyles((theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
	sourceAvatar: {
		width: '10em',
		height: '10em',
	},
	approvalViewer: {
		'& iframe': {
			width: '40em',
			height: '40em',
		},
	},
}));

// adding close button for dialog.
const DialogTitle = (props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
};
// Component to just view source file in a dialog.
const SourceViewerDialog = ({ label, modelUrl, size, type, name, createdDate, imageUrl }) => {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const handleClose = () => {
		setOpen(false);
	};
	const handleClickOpen = () => {
		setOpen(true);
	};
	const titleProps = {
		classes,
		onClose: handleClose,
	};
	return (
		<>
			<Button onClick={handleClickOpen}>
				<Avatar src={imageUrl} variant="square" className={classes.sourceAvatar}>
					Source File
					<ZoomInIcon />
				</Avatar>
			</Button>
			<Dialog
				open={open}
				className={classes.dialog}
				fullWidth={true}
				onClose={handleClose}
				aria-labelledby="approval-viewer-dialog"
				data-cy="approval-viewer-dialog"
				maxWidth="lg"
			>
				<DialogTitle id="approval-viewer-dialog" {...titleProps}>
					{label}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="approval-viewer-dialog"></DialogContentText>
					<div className={classes.approvalViewer}>{open ? <ApprovalViewer modelUrl={modelUrl} /> : ''}</div>
					<SourceViewerDialogFields name={name} createdDate={createdDate} size={size} />
				</DialogContent>
			</Dialog>
		</>
	);
};

export default SourceViewerDialog;
